export default __webpack_public_path__ + "static/news-and-updates-922f7949ddfd9d646cfc750e34abe5c6.jpg";